import React from 'react';

import { Outlet } from 'react-router-dom';

import { DashboardNotFound } from '@features/insights/pages/dashboard-not-found/dashboard-not-found';
import UnavailablePage from '@features/insights/pages/unavailable/unavailable.page';
import { InsightsBaseErrorBoundary } from '@packages/insights-widgets/components/insights-error-boundary/insights-base-error-boundary';

import { DashboardSkeletonLoader } from '../dashboard-skeleton-loader/dashboard-skeleton-loader';

export const DashboardManagerBase = () => {
  return (
    <InsightsBaseErrorBoundary
      notFoundFallback={<DashboardNotFound />}
      fallback={<UnavailablePage />}
    >
      <React.Suspense fallback={<DashboardSkeletonLoader widgetCount={6} />}>
        <Outlet />
      </React.Suspense>
    </InsightsBaseErrorBoundary>
  );
};
